import { useRouter } from 'next/router';
import { useMemo } from 'react';

export function useEventID() {
  const { query } = useRouter();
  const eventId: string = useMemo(() => {
    if (typeof query.eventid === 'string') {
      return query.eventid;
    }
    if (Array.isArray(query.eventid)) {
      const id = query.eventid[0];
      return id || '';
    }
    return '';
  }, [query.eventid]);

  return { eventId };
}
